import * as React from "react";
import { inputTheme } from "../inputs";
import { List, ListProps } from "./List";
import { SearchField } from "./SearchField";
import { useSearchInputForList } from "./useSearchForList";

export type SearchableListProps<TItem> = ListProps<TItem> & {
    searchWrapperClassName?: string;
    searchFieldTheme?: inputTheme | inputTheme[];
    searchFieldPlaceholder?: string;
    inputRef?: React.MutableRefObject<SearchField>;
};

export function SearchableList<TItem extends {}>(props: SearchableListProps<TItem>) {
    const { searchText, setSearchText, onSearchInputKeyDown, listRef } = useSearchInputForList<TItem>();
    const { searchWrapperClassName, searchFieldTheme, searchFieldPlaceholder, inputRef, ...listProps } = props;

    return (
        <>
            {!props.isLoading && (
                <div className={searchWrapperClassName}>
                    <SearchField
                        value={searchText}
                        onFilterTextChange={setSearchText}
                        onKeyDown={onSearchInputKeyDown}
                        placeholder={searchFieldPlaceholder}
                        theme={searchFieldTheme}
                        ref={inputRef}
                    />
                </div>
            )}
            <List<TItem> {...listProps} searchText={searchText} ref={listRef} ignoreHomeEndNavigation={true} />
        </>
    );
}
